import React from "react";
import { FlexCenter } from "../../../../layout/FlexCenter/FlexCenter";
import { GridTable } from "../../../../layout/GridTable/GridTable";
import { Badge } from "../../../../shared/Badge/Badge";
import IconComponent from "../../../../shared/IconComponents/IconComponent";
import { TextCustom } from "../../../../ui/TextCustom";
import { TManagerScriptSettings, TWebsocketScriptSettings } from "../../../../../interface/interfaces";

interface IScriptUpdateCardProps {
    index: number;
    localVersion: string;
    gitVersion: string;
    script: string;
    scriptUpdateWsData: TManagerScriptSettings[];
    noVersion: string;
    isOnlyLocal?: boolean;
    shouldUpdate: boolean;
    gitStatus: string;
    localStatus: string;
}

export const ScriptUpdateCard: React.FC<IScriptUpdateCardProps> = ({gitStatus, localStatus, index, localVersion, gitVersion, script, scriptUpdateWsData, noVersion, isOnlyLocal, shouldUpdate}) => {
    return (
        <GridTable gridTemplateColumns='400px 100px 100px' key={index} hasSeparator={index !== scriptUpdateWsData.length - 1}>
        <FlexCenter direction="v" position="start" gap={1}>
            <IconComponent size={1.6} iconName={`${isOnlyLocal ? 'Files_dark' : 'File'}`}/>
            <FlexCenter direction="v" position="center" gap={1}>
                <TextCustom color={`${localStatus !== 'ERROR' ? 'grey-dark' : 'error'}`} size={1} weight={localStatus !== 'ERROR' ? 500 : 700}>{script}</TextCustom>
                {
                    localStatus === "ERROR"
                    &&
                    <IconComponent size={1.2} iconName={'NOT_OK'}/>
                }
            </FlexCenter>
            {shouldUpdate && <TextCustom color={`${gitVersion === noVersion ? 'error' : 'accent-green'}`}>*</TextCustom>}
        </FlexCenter>
        {
            localVersion !== "No file"
            ?
            <FlexCenter direction="v" position="start" gap={1}>
                <Badge fontSize={1} radius="s" label={localVersion} color={`${localVersion === noVersion ? 'accent-orange' : 'grey-dark'}`}/>
            </FlexCenter>
            :
            // ako nema fajla
            <div></div>
        }

        
        {
            !isOnlyLocal
            ?
            gitVersion !== noVersion
            ?
            <FlexCenter direction="v" position="start" gap={1}>
                {/* <h1>{gitStatus}</h1> */}
                <Badge fontSize={1}  radius="s" label={gitVersion} color={`${gitVersion === noVersion ? 'accent-orange' : localVersion !== gitVersion ? 'accent-green' : 'grey-dark'}`}/>
            </FlexCenter>
            :
            // ako ne postoji verzija
            <FlexCenter direction="v" position="start" gap={1}>
                <Badge fontSize={1} radius="s" label={noVersion} color={`accent-orange`}/>
            </FlexCenter>

            :
            // ako je only local
            <div></div>
        }
    </GridTable>
    )
}